const REPORT_GROUP_BY_ENUM = {
  PERIOD: 'period',

  // PRODUCT GROUPING
  PRODUCT_TITLE: 'product_title',
  PRODUCT_NAME: 'product_name',
  VARIANT_NAME: 'variant_name',
  VARIANT_SKU: 'variant_sku',
  PRODUCT_VENDOR: 'product_vendor',

  // PAYMENT GROUPING
  STORE: 'store',
  ORDER_ID: 'order_id',
  PAYMENT_ID: 'payment_id',
  SHIPPING_CITY: 'shipping_city',
  CUSTOMER_EMAIL: 'customer_email',
  FUNDRAISER_NAME: 'fundraiser_name',
  SPORTSHEADZ_SERVICE_TYPE: 'sportsheadz_service_type'
};

const REPORT_HEADER_ORDER_ENUM = {
  STORE: 'store',
  SPORTSHEADZ_SERVICE_TYPE: 'sportsheadz_service_type',
  SERVICE_FEES: 'service_fees',
  TIERED_PRICING_FEES: 'tiered_pricing_fees',
  ADJUSTMENT: 'adjustment',
  ORDER_VALUE: 'order_value',
  AVERAGE_ORDER_VALUE: 'average_order_value',
  AMOUNT_PAID: 'amount_paid',
  AMOUNT_REFUNDED: 'amount_refunded',
  AMOUNT_DISCOUNTED: 'amount_discounted',
  FULFILLMENT_STATUS: 'fulfillment_status',
  GROSS_MARGIN: 'gross_margin',
  GROSS_SALES: 'gross_sales',
  NET_PROFIT: 'net_profit',
  NET_SALES: 'net_sales',
  ESCROW_AMOUNT_EARNED: 'escrow_amount_earned',
  ESCROW_AMOUNT_PAID: 'escrow_amount_paid',
  ESCROW_BALANCE: 'escrow_balance',
  ORDER_ID: 'order_id',
  ORDER_COUNT: 'order_count',
  SHIPPING_COST: 'shipping_cost',
  BUNDLE_PRICE_RECONCILIATION: 'bundle_price_reconciliation',
  TAXES: 'taxes',
  TOTAL_SALES: 'total_sales',
  SHIPPED_ORDERS: 'shipped_orders',
  DELIVERED_ORDERS: 'delivered_orders',
  FULFILLED_ORDERS: 'fulfilled_orders',
  DATE: 'date',
  TRANSACTION_COUNT: 'transaction_count',
  PAYMENT_COUNT: 'payment_count',
  PURCHASE_DATE: 'purchase_date',
  IS_ESCROW_PAYMENT: 'is_escrow_payment',
  EXTERNAL_PRODUCT_COST: 'external_product_cost',
  EXTERNAL_SHIPPING_COST: 'external_shipping_cost',
  EXTERNAL_TOTAL_COST: 'external_total_cost'
};

const REPORT_HEADER_CUSTOMER_ENUM = {
  CUSTOMER_ID: 'customer_id',
  CUSTOMER_EMAIL: 'customer_email',
  CUSTOMER_NAME: 'customer_name',
  CUSTOMER_COUNT: 'customer_count',
  IS_RETURNING: 'is_returning',
  FIRST_ORDER_DATE: 'first_order_date',
  LAST_ORDER_DATE: 'last_order_date'
};

const REPORT_HEADER_PRODUCT_ENUM = {
  PRODUCT_ID: 'product_id',
  PRODUCT_TITLE: 'product_title',
  PRODUCT_NAME: 'product_name',
  PRODUCT_VENDOR: 'product_vendor',
  VARIANT_ID: 'variant_id',
  VARIANT_NAME: 'variant_name',
  VARIANT_SKU: 'variant_sku',
  PRODUCT_COST: 'product_cost',
  COST_PER_ITEM: 'cost_per_item',
  ORDERED_QUANTITY: 'ordered_quantity',
  UNITS_ORDERED: 'units_ordered',
  AVERAGE_UNITS_ORDERED: 'average_units_ordered',
  REFUNDED_UNITS: 'refunded_units',
  REFUND_RATE: 'refund_rate',
  NET_QUANTITY: 'net_quantity'
};

const REPORT_HEADER_SHIPPING_ENUM = {
  SHIPPING_ADDRESS: 'shipping_address',
  SHIPPING_CITY: 'shipping_city',
  SHIPPING_COUNTRY: 'shipping_country',
  SHIPPING_POSTAL_CODE: 'shipping_postal_code',
  SHIPPING_PROVINCE: 'shipping_province'
};

const REPORT_HEADER_FUNDRAISER_ENUM = {
  FUNDRAISER_NAME: 'fundraiser_name',
  FUNDRAISER_CUSTOM_INPUT: 'fundraiser_custom_input',
  SALES_WTIH_FUNDRAISER: 'sales_with_fundraiser'
};

const REPORT_HEADER_ADMIN_ENUM = {
  STRIPE_PRODUCT_FEES: 'stripe_product_fees',
  STRIPE_ADJUSTMENT_FEES: 'stripe_adjustment_fees',
  STRIPE_TOTAL_FEES: 'stripe_total_fees',
  SPORTSHEADZ_CREDIT: 'sportsheadz_credit',
  SPORTSHEADZ_EXTERNAL_FEES: 'sportsheadz_external_fees',
  SPORTSHEADZ_FEES: 'sportsheadz_fees',
  SPORTSHEADZ_PROFIT: 'sportsheadz_profit',
  VENDOR_AMOUNT_PAID: 'vendor_amount_paid',
  VENDOR_PAYOUT_BALANCE: 'vendor_payout_balance',
  DUPLIUM_PRODUCT_COST: 'duplium_product_cost',
  DUPLIUM_SHIPPING_COST: 'duplium_shipping_cost',
  DUPLIUM_TOTAL_COST: 'duplium_total_cost',
  PRINTIFY_PRODUCT_COST: 'printify_product_cost',
  PRINTIFY_SHIPPING_COST: 'printify_shipping_cost',
  PRINTIFY_TOTAL_COST: 'printify_total_cost',

  // CTA
  CTA_COUNT: 'cta_count',
  CTA_CAPTURED: 'cta_captured',
  CTA_ASSOCIATION_PAGE_HEADER_COUNT: 'cta_association_page_header_count',
  CTA_ORDER_SUMMARY_COUNT: 'cta_order_summary_count',
  CTA_CART_FOOTER_COUNT: 'cta_cart_footer_count',
  CTA_FORM_SUBMISSION_FOOTER_COUNT: 'cta_form_submission_footer_count',
  CTA_PRODUCT_DETAILS_PAGE_FOOTER_COUNT:
    'cta_product_details_page_footer_count',
  CTA_CART_NAVIGATION_TO_ASSOCIATION_PAGE_COUNT:
    'cta_cart_navigation_to_association_page_count'
};

const REPORT_HEADER_TYPE_ENUM = {
  CURRENCY: 1,
  NUMBER: 2,
  STRING: 3,
  DATE: 4,
  BOOLEAN: 5
};

const REPORT_FIELD_COMPARE_VALUES = {
  IS: 'is',
  IS_NOT: 'is_not',
  IN: 'in',
  IS_NOT_IN: 'is_not_in',
  CONTAINS: 'contains',
  DOES_NOT_CONTAIN: 'does_not_contain',
  GREATER_THAN: 'greater_than',
  GREATER_THAN_OR_EQUAL: 'greater_than_or_equal',
  LESS_THAN: 'less_than',
  LESS_THAN_OR_EQUAL: 'less_than_or_equal'
};

const REPORT_FIELD_COMPARE_OPTIONS = [
  { value: REPORT_FIELD_COMPARE_VALUES.IS, label: 'Is' },
  { value: REPORT_FIELD_COMPARE_VALUES.IS_NOT, label: 'Is not' },
  {
    value: REPORT_FIELD_COMPARE_VALUES.IN,
    label: 'In',
    bounds: [REPORT_HEADER_TYPE_ENUM.STRING]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.IS_NOT_IN,
    label: 'Is not in',
    bounds: [REPORT_HEADER_TYPE_ENUM.STRING]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.CONTAINS,
    label: 'Contains',
    bounds: [REPORT_HEADER_TYPE_ENUM.STRING]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.DOES_NOT_CONTAIN,
    label: 'Does not contain',
    bounds: [REPORT_HEADER_TYPE_ENUM.STRING]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.GREATER_THAN,
    label: 'Greater than',
    bounds: [
      REPORT_HEADER_TYPE_ENUM.NUMBER,
      REPORT_HEADER_TYPE_ENUM.CURRENCY,
      REPORT_HEADER_TYPE_ENUM.DATE
    ]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.GREATER_THAN_OR_EQUAL,
    label: 'Greater than or equal',
    bounds: [
      REPORT_HEADER_TYPE_ENUM.NUMBER,
      REPORT_HEADER_TYPE_ENUM.CURRENCY,
      REPORT_HEADER_TYPE_ENUM.DATE
    ]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.LESS_THAN,
    label: 'Less than',
    bounds: [
      REPORT_HEADER_TYPE_ENUM.NUMBER,
      REPORT_HEADER_TYPE_ENUM.CURRENCY,
      REPORT_HEADER_TYPE_ENUM.DATE
    ]
  },
  {
    value: REPORT_FIELD_COMPARE_VALUES.LESS_THAN_OR_EQUAL,
    label: 'Less than or equal',
    bounds: [
      REPORT_HEADER_TYPE_ENUM.NUMBER,
      REPORT_HEADER_TYPE_ENUM.CURRENCY,
      REPORT_HEADER_TYPE_ENUM.DATE
    ]
  }
];

const REPORT_FIELD_LOGIC_OPERATORS = [
  {
    value: 'and',
    label: 'And',
    blockedBounds: [REPORT_FIELD_COMPARE_VALUES.IS]
  },
  {
    value: 'or',
    label: 'Or',
    blockedBounds: [REPORT_FIELD_COMPARE_VALUES.IS_NOT]
  }
];

const REPORT_HEADER_LIST = [
  // ADMIN
  {
    value: REPORT_HEADER_ADMIN_ENUM.STRIPE_PRODUCT_FEES,
    label: 'Stripe product fees',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.STRIPE_ADJUSTMENT_FEES,
    label: 'Stripe adjustment fees',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.STRIPE_TOTAL_FEES,
    label: 'Stripe total fees',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.SPORTSHEADZ_CREDIT,
    label: 'SportsHeadz credit',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.SPORTSHEADZ_FEES,
    label: 'SportsHeadz fees',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.SPORTSHEADZ_PROFIT,
    label: 'SportsHeadz profit',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.VENDOR_AMOUNT_PAID,
    label: 'Vendor amount paid',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.VENDOR_PAYOUT_BALANCE,
    label: 'Vendor payout balance',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.DUPLIUM_PRODUCT_COST,
    label: 'Duplium product cost',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.DUPLIUM_SHIPPING_COST,
    label: 'Duplium shipping cost',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.DUPLIUM_TOTAL_COST,
    label: 'Duplium total cost',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.PRINTIFY_PRODUCT_COST,
    label: 'Printify product cost',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.PRINTIFY_SHIPPING_COST,
    label: 'Printify shipping cost',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.PRINTIFY_TOTAL_COST,
    label: 'Printify total cost',
    category: 'Admin',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },

  // ADMIN CTA
  {
    value: REPORT_HEADER_ADMIN_ENUM.CTA_COUNT,
    label: 'CTA total count',
    category: 'CTA',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.CTA_CAPTURED,
    label: 'CTA captured',
    category: 'CTA',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.CTA_ASSOCIATION_PAGE_HEADER_COUNT,
    label: 'CTA count (Association Header)',
    category: 'CTA',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.CTA_ORDER_SUMMARY_COUNT,
    label: 'CTA count (Order summary)',
    category: 'CTA',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.CTA_CART_FOOTER_COUNT,
    label: 'CTA count (Cart footer)',
    category: 'CTA',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.CTA_FORM_SUBMISSION_FOOTER_COUNT,
    label: 'CTA count (Registration form)',
    category: 'CTA',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_ADMIN_ENUM.CTA_PRODUCT_DETAILS_PAGE_FOOTER_COUNT,
    label: 'CTA count (Product details footer)',
    category: 'CTA',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value:
      REPORT_HEADER_ADMIN_ENUM.CTA_CART_NAVIGATION_TO_ASSOCIATION_PAGE_COUNT,
    label: 'CTA count (Cart product details)',
    category: 'CTA',
    allowedViews: ['admin'],
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },

  // ORDER
  {
    value: REPORT_HEADER_ORDER_ENUM.STORE,
    label: 'Store',
    category: 'Order',
    allowedViews: ['vendor', 'admin'],
    type: REPORT_HEADER_TYPE_ENUM.STRING,
    getNavLink: ({ value, urlBase, resources }, isAdminView) => {
      const storeId = resources
        .find((r) => r.dataField === 'store')
        ?.resourceData.find((d) => d.data.name === value)?.id;

      return storeId
        ? isAdminView
          ? `/admin/stores/${storeId}`
          : `${urlBase}/merchant/${storeId}`
        : null;
    }
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.SPORTSHEADZ_SERVICE_TYPE,
    label: 'Service',
    category: 'Order',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.ORDER_ID,
    label: 'Order ID',
    category: 'Order',
    type: REPORT_HEADER_TYPE_ENUM.STRING,
    getNavLink: ({ value, urlBase, resources }, isAdminView) =>
      value ? `${urlBase}/orders/${value.replace('#', '')}` : null
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.FULFILLMENT_STATUS,
    label: 'Fulfillment status',
    category: 'Order',
    type: REPORT_HEADER_TYPE_ENUM.STRING,
    options: [
      { value: 'Fulfilled', label: 'Fulfilled' },
      { value: 'Cancelled', label: 'Cancelled' },
      { value: 'Unfilfilled', label: 'Unfilfilled' }
    ]
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.SHIPPED_ORDERS,
    label: 'Shipped orders',
    category: 'Order',
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.FULFILLED_ORDERS,
    label: 'Fulfilled orders',
    category: 'Order',
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_PRODUCT_ENUM.PRODUCT_COST,
    label: 'Product cost',
    category: 'Product',
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_PRODUCT_ENUM.COST_PER_ITEM,
    label: 'Cost per item',
    category: 'Product',
    allowedViews: ['admin', 'vendor'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.BUNDLE_PRICE_RECONCILIATION,
    label: 'Bundle price reconciliation',
    category: 'Order',
    allowedViews: ['admin', 'store'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.ADJUSTMENT,
    label: 'Adjustment',
    category: 'Order',
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.AVERAGE_ORDER_VALUE,
    label: 'Average order value',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.AMOUNT_PAID,
    label: 'Amount paid',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
    label: 'Amount refunded',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.AMOUNT_DISCOUNTED,
    label: 'Amount discounted',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.SERVICE_FEES,
    label: 'Service fees',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.TIERED_PRICING_FEES,
    label: 'Platform fees',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
    label: 'Gross sales',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.NET_PROFIT,
    label: 'Net profit',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.GROSS_MARGIN,
    label: 'Gross margin',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.IS_ESCROW_PAYMENT,
    label: 'Is escrow payment',
    category: 'Order',
    allowedViews: ['admin', 'store'],
    type: REPORT_HEADER_TYPE_ENUM.BOOLEAN
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.ESCROW_AMOUNT_EARNED,
    label: 'Escrow amount earned',
    category: 'Order',
    allowedViews: ['admin', 'store'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.ESCROW_AMOUNT_PAID,
    label: 'Escrow amount paid',
    category: 'Order',
    allowedViews: ['admin', 'store'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.ESCROW_BALANCE,
    label: 'Escrow balance',
    category: 'Order',
    allowedViews: ['admin', 'store'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.NET_SALES,
    label: 'Net sales',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.TOTAL_SALES,
    label: 'Total sales',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.SHIPPING_COST,
    label: 'Shipping cost',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.TAXES,
    label: 'Taxes',
    category: 'Order',
    chartable: true,
    allowedViews: ['admin', 'store'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
    label: 'Order count',
    category: 'Order',
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.TRANSACTION_COUNT,
    label: 'Transaction count',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.PAYMENT_COUNT,
    label: 'Payment count',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.PURCHASE_DATE,
    label: 'Purchase date',
    category: 'Order',
    chartable: true,
    type: REPORT_HEADER_TYPE_ENUM.DATE
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.EXTERNAL_PRODUCT_COST,
    label: 'External product cost',
    category: 'Order',
    chartable: true,
    allowedViews: ['admin', 'vendor'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.EXTERNAL_SHIPPING_COST,
    label: 'External shipping cost',
    category: 'Order',
    chartable: true,
    allowedViews: ['admin', 'vendor'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },
  {
    value: REPORT_HEADER_ORDER_ENUM.EXTERNAL_TOTAL_COST,
    label: 'External total cost',
    category: 'Order',
    chartable: true,
    allowedViews: ['admin', 'vendor'],
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },

  // CUSTOMER
  {
    value: REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_EMAIL,
    label: 'Customer email',
    category: 'Customer',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_ID,
    label: 'Customer ID',
    category: 'Customer',
    type: REPORT_HEADER_TYPE_ENUM.STRING,
    getNavLink: ({ value, urlBase, resources }, isAdminView) =>
      value
        ? isAdminView
          ? `/admin/customers/${value}`
          : `${urlBase}/customers/${value}`
        : null
  },
  {
    value: REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_NAME,
    label: 'Customer name',
    category: 'Customer',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_COUNT,
    label: 'Customer count',
    category: 'Customer',
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_CUSTOMER_ENUM.IS_RETURNING,
    label: 'Is returning',
    category: 'Customer',
    type: REPORT_HEADER_TYPE_ENUM.BOOLEAN
  },
  {
    value: REPORT_HEADER_CUSTOMER_ENUM.FIRST_ORDER_DATE,
    label: 'First order date',
    category: 'Customer',
    type: REPORT_HEADER_TYPE_ENUM.BOOLEAN
  },
  {
    value: REPORT_HEADER_CUSTOMER_ENUM.LAST_ORDER_DATE,
    label: 'Last order date',
    category: 'Customer',
    type: REPORT_HEADER_TYPE_ENUM.DATE
  },

  // PRODUCT
  {
    value: REPORT_HEADER_PRODUCT_ENUM.PRODUCT_ID,
    label: 'Product ID',
    category: 'Product',
    type: REPORT_HEADER_TYPE_ENUM.NUMBER,
    getNavLink: ({ value, urlBase, resources }, isAdminView) => {
      const productUuid = resources
        .find((r) => r.dataField === 'product')
        ?.resourceData.find((d) => d.uuid === value)?.uuid;

      return productUuid
        ? isAdminView
          ? `/vendor/products/${productUuid}`
          : `${urlBase}/merchant/${productUuid}`
        : null;
    }
  },
  {
    value: REPORT_HEADER_PRODUCT_ENUM.PRODUCT_TITLE,
    label: 'Product title',
    category: 'Product',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_PRODUCT_ENUM.PRODUCT_NAME,
    label: 'Product name',
    category: 'Product',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_PRODUCT_ENUM.PRODUCT_VENDOR,
    label: 'Product vendor',
    category: 'Product',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_PRODUCT_ENUM.VARIANT_ID,
    label: 'Variant ID',
    category: 'Product',
    type: REPORT_HEADER_TYPE_ENUM.STRING,
    getNavLink: ({ value, urlBase, resources }, isAdminView) => {
      const productUuid = resources
        .find((r) => r.dataField === 'variant')
        ?.resourceData.find((d) => d.uuid === value)?.data.productUuid;

      return productUuid
        ? isAdminView
          ? `/vendor/products/${productUuid}/variants/${value}`
          : `${urlBase}/merchant/${productUuid}/variants/${value}`
        : null;
    }
  },
  {
    value: REPORT_HEADER_PRODUCT_ENUM.VARIANT_NAME,
    label: 'Variant name',
    category: 'Product',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_PRODUCT_ENUM.VARIANT_SKU,
    label: 'Variant SKU',
    category: 'Product',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_PRODUCT_ENUM.ORDERED_QUANTITY,
    label: 'Ordered quantity',
    category: 'Product',
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_PRODUCT_ENUM.AVERAGE_UNITS_ORDERED,
    label: 'Average units ordered',
    category: 'Product',
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_PRODUCT_ENUM.REFUNDED_UNITS,
    label: 'Refunded units',
    category: 'Product',
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_PRODUCT_ENUM.REFUND_RATE,
    label: 'Refund rate',
    category: 'Product',
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  },
  {
    value: REPORT_HEADER_PRODUCT_ENUM.NET_QUANTITY,
    label: 'Net quantity',
    category: 'Product',
    type: REPORT_HEADER_TYPE_ENUM.CURRENCY
  },

  // SHIPPING
  {
    value: REPORT_HEADER_SHIPPING_ENUM.SHIPPING_ADDRESS,
    label: 'Shipping address',
    category: 'Shipping',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_SHIPPING_ENUM.SHIPPING_CITY,
    label: 'Shipping city',
    category: 'Shipping',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_SHIPPING_ENUM.SHIPPING_PROVINCE,
    label: 'Shipping province',
    category: 'Shipping',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_SHIPPING_ENUM.SHIPPING_COUNTRY,
    label: 'Shipping country',
    category: 'Shipping',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_SHIPPING_ENUM.SHIPPING_POSTAL_CODE,
    label: 'Shipping postal code',
    category: 'Shipping',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },

  // FUNDRAISER
  {
    value: REPORT_HEADER_FUNDRAISER_ENUM.FUNDRAISER_NAME,
    label: 'Fundraiser name',
    category: 'Fundraiser',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_FUNDRAISER_ENUM.FUNDRAISER_CUSTOM_INPUT,
    label: 'Fundraiser custom input',
    category: 'Fundraiser',
    type: REPORT_HEADER_TYPE_ENUM.STRING
  },
  {
    value: REPORT_HEADER_FUNDRAISER_ENUM.SALES_WTIH_FUNDRAISER,
    label: 'Sales with fundraiser',
    category: 'Fundraiser',
    type: REPORT_HEADER_TYPE_ENUM.NUMBER
  }
];

const REPORT_CATEGORY_ENUM = {
  SALES: '1',
  CUSTOMERS: '2',
  ORDERS: '3',
  FINANCES: '4'
};

const REPORT_CATEGORY_LIST = [
  {
    label: 'Sales',
    value: REPORT_CATEGORY_ENUM.SALES
  },
  {
    label: 'Customers',
    value: REPORT_CATEGORY_ENUM.CUSTOMERS
  },
  {
    label: 'Orders',
    value: REPORT_CATEGORY_ENUM.ORDERS
  },
  {
    label: 'Finances',
    value: REPORT_CATEGORY_ENUM.FINANCES
  }
];

const REPORT_TYPE_ENUM = {
  SALES: '1',
  CUSTOMERS: '2',
  ORDERS: '3'
};

const DEFAULT_REPORT_HEADERS = [
  // ADMIN
  REPORT_HEADER_ADMIN_ENUM.STRIPE_PRODUCT_FEES,
  REPORT_HEADER_ADMIN_ENUM.STRIPE_ADJUSTMENT_FEES,
  REPORT_HEADER_ADMIN_ENUM.STRIPE_TOTAL_FEES,
  REPORT_HEADER_ADMIN_ENUM.SPORTSHEADZ_CREDIT,
  REPORT_HEADER_ADMIN_ENUM.SPORTSHEADZ_EXTERNAL_FEES,
  REPORT_HEADER_ADMIN_ENUM.SPORTSHEADZ_FEES,
  REPORT_HEADER_ADMIN_ENUM.SPORTSHEADZ_PROFIT,
  REPORT_HEADER_ADMIN_ENUM.VENDOR_AMOUNT_PAID,
  REPORT_HEADER_ADMIN_ENUM.VENDOR_PAYOUT_BALANCE,
  REPORT_HEADER_ADMIN_ENUM.DUPLIUM_PRODUCT_COST,
  REPORT_HEADER_ADMIN_ENUM.DUPLIUM_SHIPPING_COST,
  REPORT_HEADER_ADMIN_ENUM.DUPLIUM_TOTAL_COST,
  REPORT_HEADER_ADMIN_ENUM.PRINTIFY_PRODUCT_COST,
  REPORT_HEADER_ADMIN_ENUM.PRINTIFY_SHIPPING_COST,
  REPORT_HEADER_ADMIN_ENUM.PRINTIFY_TOTAL_COST,
  REPORT_HEADER_ADMIN_ENUM.CTA_CAPTURED,
  REPORT_HEADER_ADMIN_ENUM.CTA_COUNT,
  REPORT_HEADER_ADMIN_ENUM.CTA_ASSOCIATION_PAGE_HEADER_COUNT,
  REPORT_HEADER_ADMIN_ENUM.CTA_ORDER_SUMMARY_COUNT,
  REPORT_HEADER_ADMIN_ENUM.CTA_CART_FOOTER_COUNT,
  REPORT_HEADER_ADMIN_ENUM.CTA_FORM_SUBMISSION_FOOTER_COUNT,
  REPORT_HEADER_ADMIN_ENUM.CTA_PRODUCT_DETAILS_PAGE_FOOTER_COUNT,
  REPORT_HEADER_ADMIN_ENUM.CTA_CART_NAVIGATION_TO_ASSOCIATION_PAGE_COUNT,

  // ORDER
  REPORT_HEADER_ORDER_ENUM.STORE,
  REPORT_HEADER_ORDER_ENUM.SPORTSHEADZ_SERVICE_TYPE,
  REPORT_HEADER_ORDER_ENUM.AMOUNT_PAID,
  REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
  REPORT_HEADER_ORDER_ENUM.SERVICE_FEES,
  REPORT_HEADER_ORDER_ENUM.TIERED_PRICING_FEES,
  REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
  REPORT_HEADER_ORDER_ENUM.GROSS_MARGIN,
  REPORT_HEADER_ORDER_ENUM.NET_PROFIT,
  REPORT_HEADER_ORDER_ENUM.NET_SALES,
  REPORT_HEADER_ORDER_ENUM.SHIPPING_COST,
  REPORT_HEADER_ORDER_ENUM.BUNDLE_PRICE_RECONCILIATION,
  REPORT_HEADER_ORDER_ENUM.TAXES,
  REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
  REPORT_HEADER_ORDER_ENUM.SHIPPED_ORDERS,
  REPORT_HEADER_ORDER_ENUM.FULFILLED_ORDERS,
  REPORT_HEADER_ORDER_ENUM.TOTAL_SALES,
  REPORT_HEADER_ORDER_ENUM.TRANSACTION_COUNT,
  REPORT_HEADER_ORDER_ENUM.PAYMENT_COUNT,
  REPORT_HEADER_ORDER_ENUM.IS_ESCROW_PAYMENT,
  REPORT_HEADER_ORDER_ENUM.ESCROW_AMOUNT_EARNED,
  REPORT_HEADER_ORDER_ENUM.ESCROW_AMOUNT_PAID,
  REPORT_HEADER_ORDER_ENUM.ESCROW_BALANCE,
  REPORT_HEADER_ORDER_ENUM.EXTERNAL_PRODUCT_COST,
  REPORT_HEADER_ORDER_ENUM.EXTERNAL_SHIPPING_COST,
  REPORT_HEADER_ORDER_ENUM.EXTERNAL_TOTAL_COST,

  // CUSTOMER
  REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_ID,
  REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_EMAIL,
  REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_NAME,
  REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_COUNT,

  // PRODUCT
  REPORT_HEADER_PRODUCT_ENUM.PRODUCT_TITLE,
  REPORT_HEADER_PRODUCT_ENUM.PRODUCT_NAME,
  REPORT_HEADER_PRODUCT_ENUM.PRODUCT_VENDOR,
  REPORT_HEADER_PRODUCT_ENUM.VARIANT_ID,
  REPORT_HEADER_PRODUCT_ENUM.VARIANT_NAME,
  REPORT_HEADER_PRODUCT_ENUM.VARIANT_SKU,
  REPORT_HEADER_PRODUCT_ENUM.ORDERED_QUANTITY,
  REPORT_HEADER_PRODUCT_ENUM.UNITS_ORDERED,
  REPORT_HEADER_PRODUCT_ENUM.AVERAGE_UNITS_ORDERED,
  REPORT_HEADER_PRODUCT_ENUM.REFUNDED_UNITS,
  REPORT_HEADER_PRODUCT_ENUM.REFUND_RATE,
  REPORT_HEADER_PRODUCT_ENUM.NET_QUANTITY,
  REPORT_HEADER_PRODUCT_ENUM.PRODUCT_COST,
  REPORT_HEADER_PRODUCT_ENUM.COST_PER_ITEM,

  // SHIPPING
  REPORT_HEADER_SHIPPING_ENUM.SHIPPING_ADDRESS,
  REPORT_HEADER_SHIPPING_ENUM.SHIPPING_CITY,
  REPORT_HEADER_SHIPPING_ENUM.SHIPPING_PROVINCE,
  REPORT_HEADER_SHIPPING_ENUM.SHIPPING_COUNTRY,
  REPORT_HEADER_SHIPPING_ENUM.SHIPPING_POSTAL_CODE,

  // FUNDRAISER
  REPORT_HEADER_FUNDRAISER_ENUM.FUNDRAISER_NAME,
  REPORT_HEADER_FUNDRAISER_ENUM.FUNDRAISER_CUSTOM_INPUT,
  REPORT_HEADER_FUNDRAISER_ENUM.SALES_WTIH_FUNDRAISER
];

const REPORT_TYPE_CONFIG = [
  {
    value: REPORT_TYPE_ENUM.SALES,
    label: 'Sales',
    chartable: true,
    headers: [
      ...DEFAULT_REPORT_HEADERS,

      // ORDER
      REPORT_HEADER_ORDER_ENUM.DATE,
      REPORT_HEADER_ORDER_ENUM.ORDER_ID,
      REPORT_HEADER_ORDER_ENUM.FULFILLMENT_STATUS,
      REPORT_HEADER_ORDER_ENUM.ADJUSTMENT,
      REPORT_HEADER_ORDER_ENUM.AVERAGE_ORDER_VALUE,

      // PRODUCT
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_ID,

      // FUNDRAISER
      REPORT_HEADER_FUNDRAISER_ENUM.SALES_WTIH_FUNDRAISER
    ]
  },
  {
    value: REPORT_TYPE_ENUM.CUSTOMERS,
    label: 'Customers',
    headers: [
      ...DEFAULT_REPORT_HEADERS,

      // CUSTOMER
      REPORT_HEADER_CUSTOMER_ENUM.FIRST_ORDER_DATE,
      REPORT_HEADER_CUSTOMER_ENUM.LAST_ORDER_DATE,
      REPORT_HEADER_CUSTOMER_ENUM.IS_RETURNING,

      // FUNDRAISER
      REPORT_HEADER_FUNDRAISER_ENUM.SALES_WTIH_FUNDRAISER
    ]
  },
  {
    value: REPORT_TYPE_ENUM.ORDERS,
    label: 'Orders',
    headers: [...DEFAULT_REPORT_HEADERS]
  }
];

const ECOM_REPORT_ENUM = {
  // OVERVIEW
  OVERVIEW: 'overview',

  // SALES
  SALES_OVER_TIME: 'sales_over_time',
  AVERAGE_ORDER_VALUE: 'average_order_value',
  SALES_BY_CUSTOMER: 'sales_by_customer',
  SALES_BY_PRODUCT: 'sales_by_product',
  SALES_BY_LOCATION: 'sales_by_location',
  SALES_BY_VARIANT: 'sales_by_product_variant',
  SALES_BY_SKU: 'sales_by_sku',
  SALES_BY_FUNDRAISER: 'sales_by_fundraiser',
  SALES_BY_SERVICE: 'sales_by_service',

  // CUSTOMERS
  TOP_CUSTOMERS: 'top_customers',
  RETURNING_CUSTOMERS: 'returning_customers',
  FIRST_TIME_CUSTOMERS: 'first_time_customers',
  CUSTOMERS_BY_LOCATION: 'customers_by_location',
  CUSTOMERS_OVER_TIME: 'customers_over_time',
  FIRST_VS_RETURNING_CUSTOMERS: 'first_vs_returning_customers',

  // ORDERS
  PRODUCT_ORDERS: 'product_orders_and_returns',
  FUNDRAISER_ORDERS: 'orders_by_fundraiser',
  ORDERS_OVER_TIME: 'orders_over_time',
  ORDER_VALUE: 'order_value',
  FULFILLMENT_STATUS: 'order_fulfillment_over_time',

  // INVENTORY
  SOLD_INVENTORY_PERCENTAGE: 'sold_inventory_percentage',
  INVENTORY_VALUE: 'inventory_value',
  INVENTORY_SNAPSHOT: 'inventory_snapshot',
  INVENTORY_OVER_TIME: 'inventory_over_time',
  AVERAGE_INVENTORY_SOLD: 'average_inventory_sold',

  // FINANCES
  AMOUNT_PAID: 'amount_paid',
  FINANCE_SUMMARY: 'finance_summary',
  TOTAL_SALES: 'total_sales',
  TOTAL_REGISTRATION_SALES: 'total_registration_sales',
  REFUNDS: 'refunds',
  PAYMENTS: 'payments',
  NET_SALES: 'net_sales',
  NET_PROFIT: 'net_profit',
  SERVICE_FEES: 'service_fees',
  GROSS_PAYMENT_BY_MONTH: 'gross_payment_by_month',
  GROSS_SALES: 'gross_sales',
  COST_OF_GOODS: 'cost_of_goods',
  ESCROW_ORDERS: 'escrow_orders',

  // EXTERNAL CONNECTIONS
  EXTERNAL_SALES: 'external_sales',
  EXTERNAL_ORDERS: 'external_orders',
  EXTERNAL_PRODUCTS_SOLD: 'external_products_sold',
  EXTERNAL_REFUNDS: 'external_refunds',

  // ADMIN
  ESCROW_BALANCE: 'escrow_balance',
  VENDOR_PAYOUT_BALANCE: 'vendor_payout_balance',
  VENDOR_PAYOUT_BY_ORDER: 'vendor_payout_by_order',
  SPORTSHEADZ_PROFIT: 'sportsheadz_profit',
  SPORTSHEADZ_PROFIT_BY_ORDER: 'sportsheadz_profit_by_order',
  SALES_BY_STORE: 'sales_by_store',
  SALES_BY_VENDOR: 'sales_by_vendor',
  REGISTRATION_CTA_PERFORMANCE: 'registration_cta_performance'
};

const DEFAULT_REPORT_CONFIGS = [
  // SALES
  {
    title: 'Sales over time',
    uuid: ECOM_REPORT_ENUM.SALES_OVER_TIME,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    defaultHeaders: [
      REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
      REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_ORDER_ENUM.NET_SALES,
      REPORT_HEADER_ORDER_ENUM.TIERED_PRICING_FEES,
      REPORT_HEADER_ORDER_ENUM.TAXES,
      REPORT_HEADER_ORDER_ENUM.TOTAL_SALES
    ],
    groupBy: REPORT_GROUP_BY_ENUM.PERIOD,
    compareEnabled: true,
    chart: {
      type: 'line',
      defaultHeaderValue: REPORT_HEADER_ORDER_ENUM.TOTAL_SALES
    }
  },
  {
    title: 'Average order value over time',
    uuid: ECOM_REPORT_ENUM.AVERAGE_ORDER_VALUE,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    groupBy: REPORT_GROUP_BY_ENUM.PERIOD,
    compareEnabled: true,
    defaultHeaders: [
      REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
      REPORT_HEADER_ORDER_ENUM.TOTAL_SALES,
      REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
      REPORT_HEADER_ORDER_ENUM.AVERAGE_ORDER_VALUE,
      REPORT_HEADER_ORDER_ENUM.NET_PROFIT
    ],
    chart: {
      type: 'line',
      defaultHeaderValue: REPORT_HEADER_ORDER_ENUM.AVERAGE_ORDER_VALUE
    }
  },
  {
    title: 'Sales by customer',
    uuid: ECOM_REPORT_ENUM.SALES_BY_CUSTOMER,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    groupBy: REPORT_GROUP_BY_ENUM.CUSTOMER_EMAIL,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_EMAIL,
      REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_NAME,
      REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
      REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_ORDER_ENUM.NET_SALES,
      REPORT_HEADER_ORDER_ENUM.TOTAL_SALES,
      REPORT_HEADER_ORDER_ENUM.NET_PROFIT
    ]
  },
  {
    title: 'Sales by location',
    uuid: ECOM_REPORT_ENUM.SALES_BY_LOCATION,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    groupBy: REPORT_GROUP_BY_ENUM.SHIPPING_CITY,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_SHIPPING_ENUM.SHIPPING_CITY,
      REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
      REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_ORDER_ENUM.NET_SALES,
      REPORT_HEADER_ORDER_ENUM.TOTAL_SALES,
      REPORT_HEADER_ORDER_ENUM.NET_PROFIT
    ]
  },
  {
    title: 'Sales by fundraiser',
    uuid: ECOM_REPORT_ENUM.SALES_BY_FUNDRAISER,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    groupBy: REPORT_GROUP_BY_ENUM.FUNDRAISER_NAME,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_FUNDRAISER_ENUM.FUNDRAISER_NAME,
      REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_ORDER_ENUM.NET_SALES,
      REPORT_HEADER_ORDER_ENUM.TOTAL_SALES,
      REPORT_HEADER_ORDER_ENUM.NET_PROFIT
    ]
  },
  {
    title: 'Sales by product',
    uuid: ECOM_REPORT_ENUM.SALES_BY_PRODUCT,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    groupBy: REPORT_GROUP_BY_ENUM.PRODUCT_NAME,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_NAME,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_VENDOR,
      REPORT_HEADER_PRODUCT_ENUM.NET_QUANTITY,
      REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_ORDER_ENUM.NET_SALES,
      REPORT_HEADER_ORDER_ENUM.TOTAL_SALES,
      REPORT_HEADER_ORDER_ENUM.NET_PROFIT,
      REPORT_HEADER_ORDER_ENUM.TAXES,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_COST
    ]
  },
  {
    title: 'Sales by variant',
    uuid: ECOM_REPORT_ENUM.SALES_BY_VARIANT,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    groupBy: REPORT_GROUP_BY_ENUM.VARIANT_NAME,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_NAME,
      REPORT_HEADER_PRODUCT_ENUM.VARIANT_NAME,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_VENDOR,
      REPORT_HEADER_PRODUCT_ENUM.NET_QUANTITY,
      REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_ORDER_ENUM.NET_SALES,
      REPORT_HEADER_ORDER_ENUM.TOTAL_SALES,
      REPORT_HEADER_ORDER_ENUM.NET_PROFIT,
      REPORT_HEADER_ORDER_ENUM.TAXES,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_COST
    ]
  },
  {
    title: 'Sales by SKU',
    uuid: ECOM_REPORT_ENUM.SALES_BY_SKU,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    groupBy: REPORT_GROUP_BY_ENUM.VARIANT_SKU,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_PRODUCT_ENUM.VARIANT_SKU,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_NAME,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_VENDOR,
      REPORT_HEADER_PRODUCT_ENUM.NET_QUANTITY,
      REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_ORDER_ENUM.NET_SALES,
      REPORT_HEADER_ORDER_ENUM.TOTAL_SALES,
      REPORT_HEADER_ORDER_ENUM.NET_PROFIT,
      REPORT_HEADER_ORDER_ENUM.TAXES,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_COST
    ]
  },
  {
    title: 'Sales by service',
    uuid: ECOM_REPORT_ENUM.SALES_BY_SERVICE,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.SALES,
    defaultHeaders: [
      REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
      REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_ORDER_ENUM.NET_SALES,
      REPORT_HEADER_ORDER_ENUM.TIERED_PRICING_FEES,
      REPORT_HEADER_ORDER_ENUM.TAXES,
      REPORT_HEADER_ORDER_ENUM.TOTAL_SALES
    ],
    groupBy: REPORT_GROUP_BY_ENUM.SPORTSHEADZ_SERVICE_TYPE,
    compareEnabled: false
  },

  // CUSTOMERS
  {
    title: 'Customers by spending',
    uuid: ECOM_REPORT_ENUM.TOP_CUSTOMERS,
    fkReportType: REPORT_TYPE_ENUM.CUSTOMERS,
    fkReportCategory: REPORT_CATEGORY_ENUM.CUSTOMERS,
    groupBy: REPORT_GROUP_BY_ENUM.CUSTOMER_EMAIL,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_EMAIL,
      REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_NAME,
      REPORT_HEADER_CUSTOMER_ENUM.IS_RETURNING,
      REPORT_HEADER_CUSTOMER_ENUM.FIRST_ORDER_DATE,
      REPORT_HEADER_CUSTOMER_ENUM.LAST_ORDER_DATE,
      REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_PAID,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED
    ]
  },
  {
    title: 'First time customers',
    uuid: ECOM_REPORT_ENUM.FIRST_TIME_CUSTOMERS,
    fkReportType: REPORT_TYPE_ENUM.CUSTOMERS,
    fkReportCategory: REPORT_CATEGORY_ENUM.CUSTOMERS,
    groupBy: REPORT_GROUP_BY_ENUM.CUSTOMER_EMAIL,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_EMAIL,
      REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_NAME,
      REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_PAID,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED
    ],
    defaultFilters: [
      {
        field: REPORT_HEADER_CUSTOMER_ENUM.IS_RETURNING,
        compare: REPORT_FIELD_COMPARE_VALUES.IS,
        logicalOperator: REPORT_FIELD_LOGIC_OPERATORS[1].value,
        values: ['No']
      }
    ]
  },
  {
    title: 'Returning customers',
    uuid: ECOM_REPORT_ENUM.RETURNING_CUSTOMERS,
    fkReportType: REPORT_TYPE_ENUM.CUSTOMERS,
    fkReportCategory: REPORT_CATEGORY_ENUM.CUSTOMERS,
    groupBy: REPORT_GROUP_BY_ENUM.CUSTOMER_EMAIL,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_EMAIL,
      REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_NAME,
      REPORT_HEADER_CUSTOMER_ENUM.FIRST_ORDER_DATE,
      REPORT_HEADER_CUSTOMER_ENUM.LAST_ORDER_DATE,
      REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_PAID,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED
    ],
    defaultFilters: [
      {
        field: REPORT_HEADER_CUSTOMER_ENUM.IS_RETURNING,
        compare: REPORT_FIELD_COMPARE_VALUES.IS,
        logicalOperator: REPORT_FIELD_LOGIC_OPERATORS[1].value,
        values: ['Yes']
      }
    ]
  },
  {
    title: 'Customers over time',
    uuid: ECOM_REPORT_ENUM.CUSTOMERS_OVER_TIME,
    fkReportType: REPORT_TYPE_ENUM.CUSTOMERS,
    fkReportCategory: REPORT_CATEGORY_ENUM.CUSTOMERS,
    groupBy: REPORT_GROUP_BY_ENUM.PERIOD,
    compareEnabled: false,
    defaultHeaders: [REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_COUNT]
  },
  {
    title: 'Customers by location',
    uuid: ECOM_REPORT_ENUM.CUSTOMERS_BY_LOCATION,
    fkReportType: REPORT_TYPE_ENUM.CUSTOMERS,
    fkReportCategory: REPORT_CATEGORY_ENUM.CUSTOMERS,
    groupBy: REPORT_GROUP_BY_ENUM.SHIPPING_CITY,
    compareEnabled: false,
    defaultHeaders: [REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_COUNT]
  },

  // {
  //   title: 'First vs returning customer sales',
  //   uuid: ECOM_REPORT_ENUM.FIRST_VS_RETURNING_CUSTOMERS,
  //   fkReportType: REPORT_TYPE_ENUM.CUSTOMERS,
  //   fkReportCategory: REPORT_CATEGORY_ENUM.CUSTOMERS,
  //   groupBy: REPORT_HEADER_SHIPPING_ENUM.IS_RETURNING,
  //   compareEnabled: false,
  //   defaultHeaders: [
  //     REPORT_HEADER_CUSTOMER_ENUM.CUSTOMER_COUNT,
  //     REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
  //     REPORT_HEADER_ORDER_ENUM.AMOUNT_PAID,
  //     REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
  //     REPORT_HEADER_ORDER_ENUM.GROSS_SALES
  //   ]
  // },

  // ORDERS
  {
    title: 'Orders by product',
    uuid: ECOM_REPORT_ENUM.PRODUCT_ORDERS,
    fkReportType: REPORT_TYPE_ENUM.ORDERS,
    fkReportCategory: REPORT_CATEGORY_ENUM.ORDERS,
    groupBy: REPORT_GROUP_BY_ENUM.PRODUCT_NAME,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_NAME,
      REPORT_HEADER_PRODUCT_ENUM.ORDERED_QUANTITY,
      REPORT_HEADER_PRODUCT_ENUM.REFUNDED_UNITS,
      REPORT_HEADER_PRODUCT_ENUM.NET_QUANTITY,
      REPORT_HEADER_PRODUCT_ENUM.REFUND_RATE
    ]
  },
  {
    title: 'Orders by fundraiser',
    uuid: ECOM_REPORT_ENUM.FUNDRAISER_ORDERS,
    fkReportType: REPORT_TYPE_ENUM.ORDERS,
    fkReportCategory: REPORT_CATEGORY_ENUM.ORDERS,
    groupBy: REPORT_GROUP_BY_ENUM.FUNDRAISER_NAME,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_FUNDRAISER_ENUM.FUNDRAISER_NAME,
      REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
      REPORT_HEADER_PRODUCT_ENUM.UNITS_ORDERED,
      REPORT_HEADER_ORDER_ENUM.AVERAGE_ORDER_VALUE,
      REPORT_HEADER_PRODUCT_ENUM.REFUNDED_UNITS,
      REPORT_HEADER_PRODUCT_ENUM.REFUND_RATE
    ]
  },
  {
    title: 'Orders over time',
    uuid: ECOM_REPORT_ENUM.ORDERS_OVER_TIME,
    fkReportType: REPORT_TYPE_ENUM.ORDERS,
    fkReportCategory: REPORT_CATEGORY_ENUM.ORDERS,
    groupBy: REPORT_GROUP_BY_ENUM.PERIOD,
    compareEnabled: true,
    defaultHeaders: [
      REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
      REPORT_HEADER_PRODUCT_ENUM.UNITS_ORDERED,
      REPORT_HEADER_ORDER_ENUM.AVERAGE_ORDER_VALUE,
      REPORT_HEADER_PRODUCT_ENUM.REFUNDED_UNITS,
      REPORT_HEADER_PRODUCT_ENUM.REFUND_RATE
    ],
    chart: {
      type: 'line',
      defaultHeaderValue: REPORT_HEADER_ORDER_ENUM.ORDER_COUNT
    }
  },
  {
    title: 'Order fulfillment over time',
    uuid: ECOM_REPORT_ENUM.FULFILLMENT_STATUS,
    fkReportType: REPORT_TYPE_ENUM.ORDERS,
    fkReportCategory: REPORT_CATEGORY_ENUM.ORDERS,
    groupBy: REPORT_GROUP_BY_ENUM.PERIOD,
    compareEnabled: true,
    defaultHeaders: [
      REPORT_HEADER_ORDER_ENUM.ORDER_COUNT,
      REPORT_HEADER_ORDER_ENUM.FULFILLED_ORDERS,
      REPORT_HEADER_ORDER_ENUM.SHIPPED_ORDERS
    ]
  },

  // FINANCES
  {
    title: 'Total sales',
    uuid: ECOM_REPORT_ENUM.TOTAL_SALES,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.FINANCES,
    groupBy: REPORT_GROUP_BY_ENUM.ORDER_ID,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_ORDER_ENUM.DATE,
      REPORT_HEADER_ORDER_ENUM.ORDER_ID,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_NAME,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_PAID,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
      REPORT_HEADER_ORDER_ENUM.NET_SALES,
      REPORT_HEADER_ORDER_ENUM.TIERED_PRICING_FEES,
      REPORT_HEADER_ORDER_ENUM.TAXES,
      REPORT_HEADER_ORDER_ENUM.TOTAL_SALES,
      REPORT_HEADER_ORDER_ENUM.NET_PROFIT
    ]
  },
  {
    title: 'Total registration sales',
    uuid: ECOM_REPORT_ENUM.TOTAL_REGISTRATION_SALES,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.FINANCES,
    groupBy: REPORT_GROUP_BY_ENUM.ORDER_ID,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_ORDER_ENUM.DATE,
      REPORT_HEADER_ORDER_ENUM.ORDER_ID,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_NAME,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_PAID,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
      REPORT_HEADER_ORDER_ENUM.NET_SALES,
      REPORT_HEADER_ORDER_ENUM.TIERED_PRICING_FEES,
      REPORT_HEADER_ORDER_ENUM.TAXES,
      REPORT_HEADER_ORDER_ENUM.TOTAL_SALES,
      REPORT_HEADER_ORDER_ENUM.NET_PROFIT
    ],
    defaultFilters: [
      {
        field: REPORT_HEADER_ORDER_ENUM.SPORTSHEADZ_SERVICE_TYPE,
        compare: REPORT_FIELD_COMPARE_VALUES.IS,
        logicalOperator: REPORT_FIELD_LOGIC_OPERATORS[1].value,
        values: ['Player Registration']
      }
    ]
  },
  {
    title: 'Refunds',
    uuid: ECOM_REPORT_ENUM.REFUNDS,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.FINANCES,
    groupBy: REPORT_GROUP_BY_ENUM.ORDER_ID,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_ORDER_ENUM.DATE,
      REPORT_HEADER_ORDER_ENUM.ORDER_ID,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_NAME,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_PAID,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_PRODUCT_ENUM.ORDERED_QUANTITY,
      REPORT_HEADER_PRODUCT_ENUM.REFUNDED_UNITS,
      REPORT_HEADER_PRODUCT_ENUM.NET_QUANTITY
    ],
    defaultFilters: [
      {
        field: REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
        compare: REPORT_FIELD_COMPARE_VALUES.GREATER_THAN,
        logicalOperator: REPORT_FIELD_LOGIC_OPERATORS[0].value,
        values: ['0']
      }
    ]
  },
  {
    title: 'Payments',
    uuid: ECOM_REPORT_ENUM.PAYMENTS,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.FINANCES,
    groupBy: REPORT_GROUP_BY_ENUM.ORDER_ID,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_ORDER_ENUM.DATE,
      REPORT_HEADER_ORDER_ENUM.ORDER_ID,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_NAME,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_PAID,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_ORDER_ENUM.NET_PROFIT,
      REPORT_HEADER_ORDER_ENUM.TRANSACTION_COUNT,
      REPORT_HEADER_ORDER_ENUM.PAYMENT_COUNT,
      REPORT_HEADER_SHIPPING_ENUM.SHIPPING_COUNTRY,
      REPORT_HEADER_SHIPPING_ENUM.SHIPPING_CITY
    ]
  },
  {
    title: 'Net sales',
    uuid: ECOM_REPORT_ENUM.NET_SALES,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.FINANCES,
    groupBy: REPORT_GROUP_BY_ENUM.ORDER_ID,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_ORDER_ENUM.DATE,
      REPORT_HEADER_ORDER_ENUM.ORDER_ID,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_NAME,
      REPORT_HEADER_ORDER_ENUM.NET_SALES
    ]
  },
  {
    title: 'Gross sales',
    uuid: ECOM_REPORT_ENUM.GROSS_SALES,
    fkReportType: REPORT_TYPE_ENUM.ORDERS,
    fkReportCategory: REPORT_CATEGORY_ENUM.FINANCES,
    groupBy: REPORT_GROUP_BY_ENUM.ORDER_ID,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_ORDER_ENUM.DATE,
      REPORT_HEADER_ORDER_ENUM.ORDER_ID,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_NAME,
      REPORT_HEADER_ORDER_ENUM.GROSS_SALES
    ]
  },
  {
    title: 'Cost of goods',
    uuid: ECOM_REPORT_ENUM.COST_OF_GOODS,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.FINANCES,
    groupBy: REPORT_GROUP_BY_ENUM.ORDER_ID,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_ORDER_ENUM.DATE,
      REPORT_HEADER_ORDER_ENUM.ORDER_ID,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_TITLE,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_COST
    ]
  },
  {
    title: 'Net profit',
    uuid: ECOM_REPORT_ENUM.NET_PROFIT,
    fkReportType: REPORT_TYPE_ENUM.SALES,
    fkReportCategory: REPORT_CATEGORY_ENUM.FINANCES,
    groupBy: REPORT_GROUP_BY_ENUM.ORDER_ID,
    compareEnabled: false,
    defaultHeaders: [
      REPORT_HEADER_ORDER_ENUM.DATE,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_TITLE,
      REPORT_HEADER_ORDER_ENUM.GROSS_SALES,
      REPORT_HEADER_ORDER_ENUM.AMOUNT_REFUNDED,
      REPORT_HEADER_PRODUCT_ENUM.PRODUCT_COST,
      REPORT_HEADER_ORDER_ENUM.NET_PROFIT
    ]
  }
];

export {
  REPORT_GROUP_BY_ENUM,
  REPORT_HEADER_ADMIN_ENUM,
  REPORT_HEADER_ORDER_ENUM,
  REPORT_HEADER_CUSTOMER_ENUM,
  REPORT_HEADER_PRODUCT_ENUM,
  REPORT_HEADER_SHIPPING_ENUM,
  REPORT_HEADER_FUNDRAISER_ENUM,
  REPORT_HEADER_LIST,
  REPORT_CATEGORY_ENUM,
  REPORT_CATEGORY_LIST,
  REPORT_TYPE_ENUM,
  REPORT_TYPE_CONFIG,
  REPORT_HEADER_TYPE_ENUM,
  REPORT_FIELD_COMPARE_VALUES,
  REPORT_FIELD_COMPARE_OPTIONS,
  REPORT_FIELD_LOGIC_OPERATORS,
  ECOM_REPORT_ENUM,
  DEFAULT_REPORT_CONFIGS
};
